import { io } from 'socket.io-client';
import { store } from 'redux_toolkit/store';
import { showModal } from 'redux_toolkit/reducers/modals/modalsSlice';
import {setChats, setTyping} from 'redux_toolkit/reducers/chats/chatsSlice';

import {
  DISABLE_ENABLE_BUTTON,
  STATUS_CHAT_VALUES,
  GET_AGENTS_ROLE,
  STATUS,
  SOCKET_ROLES
} from 'configs/constants';
import {
  setNewChat,
  setNewMessage,
  endChatState,
  incomingChats,
  deleteChatRequest,
  addHistory,
  removeChat,
  addWatchingChat,
  deleteChat,
  updateWatchingChat,
  updateChat,
  messagesRead,
  setUndeliveredMessage
} from "redux_toolkit/reducers/chat/chatSlice";
import {
  addBannedVisitor,
  removeBannedVisitor,
  addPartnersVisitors,
  updatePartnerVisitor,
  addVisitorPastChat,
  addVisitorToList,
  editVisitor
} from 'redux_toolkit/reducers/partner/visitors/visitorsSlice';
import {updateUserData} from "redux_toolkit/reducers/user_partner/userPartnerSlice";
import { addNewLoggedAgent, updateAgentLocal } from 'redux_toolkit/reducers/partner/agents/agentsSlice';
import { connected } from 'redux_toolkit/reducers/connect/connectSlice';
import { hideModalChatId } from 'redux_toolkit/reducers/modals/modalsSlice';
import { removeTransferRequest, addTransferRequest } from 'redux_toolkit/reducers/current_partner/currentPartnerSlice';
import { throwOutAgent } from 'redux_toolkit/reducers/app/appSlice';
import { setMessageNotification } from 'redux_toolkit/reducers/notification/notificationSlice';

const dispatch = store.dispatch;
const url = process.env.REACT_APP_SOCKET_URL;
let socket = {};

export const connectSocket = (partnerId, userId, role, name) => {
  socket = io(`${url}/${partnerId}`, {
    auth: {
      name,
      role: SOCKET_ROLES[role],
      userId
    }
  });
}

export const getAllChats = (dispatch, localUserId) => {  
  dispatch(connected(true));
  console.log("Try Connected SOCKET!");

  socket.on('disconnect',() => {
    console.warn("Disconnect SOCKET!");
    dispatch(addPartnersVisitors({
      active: [],
      assigned: [],
      idle: [],
      incoming: [],
      served: [],
    }));
  });

  socket.on('user.update', ([agent, agents, partnerFile]) => {
    dispatch(updateUserData({ status: agent.status }));

    for(let item of agents){
      if(GET_AGENTS_ROLE[item.role]) {
        item.role = GET_AGENTS_ROLE[item.role];
        dispatch(addNewLoggedAgent(item));
      };
    }

    if (agent.transfers) {
      for(let item of agent.transfers) {
        dispatch(addTransferRequest(item));
      }
    }

    if (agent.views) {
      for(let viewChat of agent.views) {
        dispatch(addWatchingChat({chat: viewChat, messages: []}));
      }
    }

    if(agent.requests && agent.requests.length) dispatch(incomingChats(agent.requests));

    dispatch(addPartnersVisitors(agent.visitors));
  });

  socket.on('permission.ban.set', function([date, userPartnerId, banReason]){
    date ? dispatch(addBannedVisitor({_id: userPartnerId, banExpire: date, banReason})) : dispatch(removeBannedVisitor(userPartnerId));
  });

  socket.on('agents.update.status', ([userId, status, name]) => {
    let sendedData = {};
    if(name) sendedData.name = name;
    if(Number.isInteger(status)) sendedData.status = status;
    dispatch(updateAgentLocal({_id: userId, data: sendedData}));
console.log('test');
console.log(userId);
    if(STATUS.OFFLINE === status) dispatch(throwOutAgent(userId));
  });

  socket.on('chats.manual.set', chatId => {
    dispatch(incomingChats([chatId]));
  });

  socket.on('chats.manual.delete', (chatId) => {
    dispatch(deleteChatRequest({chatId}));
  });

  socket.on('chats.recover', ([chat, companionName, messages, visitorUnread, unreadCount, companionCreated]) => {
    dispatch(setNewChat({chat, messages, unreadCount, visitorUnread}));
    if(chat.status === STATUS_CHAT_VALUES.SERVED) {
      getVisitor(chat.companion._id);
      dispatch(updatePartnerVisitor({_id: chat.companion._id, name: companionName, role: 'visitors', chatId: chat._id}));
    }
    if((companionCreated)) {
      dispatch(updateChat({chatId: chat._id, data: {timeOnSite: companionCreated}}))
    };

    dispatch(setChats({_id: chat._id}))
  });

  socket.on('chats.end', (chatId) => {
    dispatch(endChatState({chatId}));
  });

  socket.on('chats.delete', (chatId) => {
    dispatch(removeChat({chatId}));
    dispatch(hideModalChatId({chatId}))
  });

  socket.on('chats.status', ([name, userId, chatId, companionCreated]) => {
    if(!isNaN(companionCreated) && companionCreated) dispatch(updateChat({chatId, data:{timeOnSite: companionCreated}}));
  });

  socket.on('message.new.log', ([chatId, message, userId, name]) => {
    dispatch(setNewMessage({chatId, message}));
  });

  socket.on('message.page', ([messages, ended, chatId]) => {
    dispatch(addHistory({chatId, messages}));
  });

  socket.on('message.new', ([message, hashId, chatId]) => {
    if(message[0] !== localUserId) dispatch(setTyping({_id: chatId, typing: false}));
    dispatch(setNewMessage({chatId, message, hashId}));
    dispatch(setMessageNotification(true));
  });

  socket.on('permission.file', ([status, chatId]) => {
    const file = status === true ? DISABLE_ENABLE_BUTTON.ENABLE:DISABLE_ENABLE_BUTTON.DISABLE;
    dispatch(updateChat({chatId, data: {file}}));
  });

  socket.on('agents.new', (agent) => {
    dispatch(addNewLoggedAgent(agent));
  });

  // TEAM LEAD
  socket.on('transfer.new.set', (chat)=> {

    dispatch(addTransferRequest(chat));
  });

  socket.on('transfer.new.delete', (chatId)=> {
    dispatch(removeTransferRequest({chatId}));
    dispatch(updateChat({chatId, data: {status: STATUS_CHAT_VALUES.SERVED}}));
  });

  socket.on('visitors.update', (visitor) => {
    console.log('test 1')
    dispatch(updatePartnerVisitor(visitor));
  });

  socket.on('chats.view', function([chat, companionName, messages, visitorUnread, unreadCount, visitorCreated]){
    dispatch(addWatchingChat({chat, companionName, messages, visitorUnread, unreadCount, visitorCreated}));
    dispatch(showModal({
      type: 'clientChat',
      canEdit: false,
      watchingAgentId: chat.user._id,
      agentName: chat.user.name,
      chatId: chat._id
    }));
  });

  socket.on('chats.views.list.update', function([chatId, oldUserId, user]){
    dispatch(updateWatchingChat({chatId, user}));
  });

  socket.on('message.read', ([userId, chatId]) => {
    if(localUserId !== userId) dispatch(messagesRead(chatId));
  });

  socket.on('message.typing', ([userId, typing, chatId]) => {
    if(localUserId === userId) return;
    dispatch(setTyping({_id: chatId, typing: typing}))
  });

  socket.on('update.visitors', ([visitorId, body]) => {
    dispatch(editVisitor({visitorId, body}))
  });

  socket.on('get.visitors', (data) => {
    dispatch(addVisitorToList(data));
  });

  socket.on('transfer.cancel', (chatId) => {
    dispatch(updateChat({chatId, data: {status: STATUS_CHAT_VALUES.SERVED}}));
  });
}

export const getChat = (newChatId)=> {
  socket.emit('chats.get', newChatId);
}

export const messageSend = (chatId, message, file)=> {
  let pictOrVideo = ['', ''];
  if(file) pictOrVideo = [file.type, file];
  const hashId = Math.random().toString(32).slice(2);
  socket.emit('message.set', [chatId, [hashId, [message, pictOrVideo]]]);

  dispatch(setUndeliveredMessage({chatId, message, hashId, file}));
}

export const messageTyping = (typing, chatId)=> {
  socket.emit('message.typing', [typing, chatId]);
}


export const endThisChat = ({chatId, companionUserId, agent, createdAt})=> {
  socket.emit('chats.end', [chatId, companionUserId]);
  dispatch(deleteChat({chatId}));
  dispatch(addVisitorPastChat({id: companionUserId, agent, createdAt}));
}

export const openChatPage = (chatId)=> {
  dispatch(updateChat({chatId, data: {unreadCount: 0, chatOpen: true}}));
  // readMessage(chatId);
}

export const readMessage = (chatId)=> {
  socket.emit('message.read', chatId);
}

export const filePermission = (chatId)=> {
  socket.emit('permission.file', chatId);
}

export const internalChat = (receiverId)=> {
  socket.emit('chats.internal.set', receiverId);
}

export const scrollMessages = (chatId, start, cb)=> {
  socket.emit('message.page', [chatId, `i${start}`]);
}

export const visitorBan = (visitorId, exp, banReason)=> {
  socket.emit('permission.ban', [visitorId, exp, banReason]);
  !exp && dispatch(removeBannedVisitor(visitorId));
}

export const transferChat = (chatId, rapid=false)=> {
  socket.emit('chats.transfer.set', [chatId, rapid]);
  dispatch(updateChat({chatId, data: {status: STATUS_CHAT_VALUES.TRANSFER}}));
}

export const transferAssign = (chatId, assignedId, rapid)=> {
  transferChat(chatId, rapid);

  socket.emit('chats.transfer.offer', [chatId, assignedId]);
}

export const viewChat = (chatId)=> {
  socket.emit('chats.view', chatId);
}

export const viewChatEnd = (chatId)=> {
  socket.emit('chats.view.end', chatId);
}

export const agentStatusUpdate = (status)=> {
  socket.emit('agents.update.status', status);
}

export const updatePartnerRequest = (status)=> {
  socket.emit('admins.set.request', +status);
}

export const logoutSocket = ()=> {
  socket.emit('logout');
}

export const logoutAgent = (agentId)=> {
  socket.emit('agents.logout', agentId);
}

export const updateActivity = (_id, status)=> {
  socket.emit('agents.inactive', [_id, status]);
  dispatch(updateAgentLocal({_id, data: {status}}));
}

export const updateVisitorData = (userPartnerId, data)=> {
  socket.emit('update.visitors', [userPartnerId, data]);
}

export const getVisitor = (userPartnerId)=> {
  socket.emit('get.visitors', [userPartnerId]);
}